import React from 'react';

import { VerificationResultModal } from '@tf/shared';
import { Button, Icon, useDisclosure } from '@tf/ui';

import type { DocumentCheck } from '../../../../../../api/documentCheck';

interface Props {
	check: DocumentCheck;
}

export const IdenfyResult: React.FC<Props> = ({ check }) => {
	const resultModal = useDisclosure();

	if (!check.data.response) {
		return null;
	}

	return (
		<>
			<Button
				size="sm"
				variant="subtle"
				onClick={resultModal.open}
				leftSection={<Icon.IconFileInfo size={18} stroke={1.5} />}
			>
				Details
			</Button>
			<VerificationResultModal
				response={check.data.response}
				attachments={check.attachments.map((f) => f.object)}
				isOpen={resultModal.isOpen}
				onModalClose={resultModal.close}
			/>
		</>
	);
};
